import { Dropdown, DropdownItem } from '@platform/components';
import { RepProjectPanel } from 'lib/client/src/platformapi.schemas';
import { DeleteProjectModalContext } from '../Modals/DeleteProjectModal';
import { useContext } from 'react';
import { MyProjects, Projects } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';

interface ProjectActionDropdownProps {
  panelData: RepProjectPanel;
}

export const ProjectActionDropdown = (props: ProjectActionDropdownProps) => {
  const { panelData } = { ...props };
  const { openDeleteProjectModal } = useContext(DeleteProjectModalContext);

  const { project } = { ...panelData };
  const { id: projectId, publishingStage } = { ...project };

  const isProjectEditable = publishingStage === 'unpublished' || publishingStage === 'draft';
  const isProjectUnderReview =
    publishingStage === 'review' || publishingStage === 'revision_requested';

  const projectIsDeletable =
    !panelData.actionRequired.length &&
    !panelData.inProgress.length &&
    !panelData.inactive.length &&
    (isProjectEditable || isProjectUnderReview);

  const queryClient = useQueryClient();

  const requestReviewMutator = Projects.useRequestReview({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MyProjects.getGetOrgUserMyProjectsQueryKey(),
        });
      },
    },
  });

  if (!projectId) {
    return null;
  }

  return (
    <Dropdown type={'icon'} ariaLabel='Dropdown button' iconName='dots-vertical'>
      {!isProjectEditable && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/dashboard/organization/request?oppId=${projectId}&actionType=clone`}
        >
          Clone
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/dashboard/organization/request?oppId=${projectId}`}
        >
          Edit
        </DropdownItem>
      )}
      {!isProjectEditable && !panelData.completed && (
        <DropdownItem
          href={`${import.meta.env['VITE_LEGACY_APP_URL']}/setup/opportunity/${projectId}/unpublish`}
        >
          Unpublish
        </DropdownItem>
      )}
      {(isProjectEditable || isProjectUnderReview) && (
        <DropdownItem
          onAction={() => {
            requestReviewMutator.mutate({
              data: { projectId },
            });
          }}
        >
          Publish
        </DropdownItem>
      )}
      {projectIsDeletable && (
        <DropdownItem
          onAction={() => {
            openDeleteProjectModal(projectId);
          }}
        >
          Delete
        </DropdownItem>
      )}
    </Dropdown>
  );
};
